$(document).ready(() => {
  // show/hide product filters
  $("#productFiltersBtn").on("click", function() {
    $("#productFilters").slideToggle();
    $("#filtersShow, #filtersHide").toggle();
  });
});
